<script setup lang="ts">
import {
  Activity,
  ArrowLeft,
  Braces,
  Gauge,
  History,
  Menu,
  ShieldCheck,
  Users,
  WalletCards,
  X,
} from "lucide-vue-next"
import { computed, ref } from "vue"
import { useRoute } from "vue-router"

import { useSessionStore } from "../stores/session"

const route = useRoute()
const session = useSessionStore()
const menuOpen = ref(false)

const navigation = [
  { name: "运营概览", to: "/admin", icon: Gauge },
  { name: "用户与额度", to: "/admin/users", icon: Users },
  { name: "套餐与订单", to: "/admin/billing", icon: WalletCards },
  { name: "接口额度", to: "/admin/capabilities", icon: Braces },
  { name: "调用记录", to: "/admin/calls", icon: History },
  { name: "平台账号与号池", to: "/admin/provider-accounts", icon: Activity },
]

const currentTitle = computed(
  () => navigation.find((item) => item.to === route.path)?.name ?? "系统管理",
)
</script>

<template>
  <div class="admin-shell">
    <aside class="admin-sidebar" :class="{ 'admin-sidebar--open': menuOpen }">
      <div class="brand-row">
        <RouterLink to="/admin" class="brand admin-brand" @click="menuOpen = false">
          <span class="brand__icon brand__icon--admin" aria-hidden="true"></span>
          <span><small>BYRE</small> 系统管理</span>
        </RouterLink>
        <button class="icon-button mobile-only" aria-label="关闭菜单" @click="menuOpen = false">
          <X :size="18" />
        </button>
      </div>

      <div class="admin-identity">
        <ShieldCheck :size="17" />
        <div>
          <span class="eyebrow">System administrator</span>
          <strong>{{ session.me?.email ?? "—" }}</strong>
        </div>
      </div>

      <nav class="side-nav" aria-label="系统管理导航">
        <RouterLink
          v-for="item in navigation"
          :key="item.to"
          :to="item.to"
          class="side-nav__item"
          @click="menuOpen = false"
        >
          <component :is="item.icon" :size="17" />
          <span>{{ item.name }}</span>
        </RouterLink>
      </nav>

      <RouterLink to="/" class="admin-back-link">
        <ArrowLeft :size="15" /> 返回用户控制台
      </RouterLink>
    </aside>

    <div v-if="menuOpen" class="sidebar-scrim" @click="menuOpen = false"></div>

    <main class="main-column">
      <header class="topbar admin-topbar">
        <div class="topbar__title">
          <button class="icon-button mobile-only" aria-label="打开菜单" @click="menuOpen = true">
            <Menu :size="19" />
          </button>
          <div><span class="eyebrow">Operations</span><strong>{{ currentTitle }}</strong></div>
        </div>
        <div class="service-status"><i></i><span>ADMIN</span><span class="desktop-only">受保护操作</span></div>
      </header>
      <div class="admin-page-frame">
        <RouterView />
      </div>
    </main>
  </div>
</template>
